import { LNGS_NAMESPACE_LOGICAL_DEVICE } from '@ingenico/util-i18n-config';
import { toString } from 'lodash-es';
import type { ReactNode } from 'react';
import { useCallback, useMemo } from 'react';
import type { UseFormReturn } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import type { FileOutputFormularyModalSchema } from '../../useFileOutputFormularyModal.hook';
import { softwareTypeOptions } from '../../useFileOutputFormularyModal.hook';
import { SelectorField } from '../SelectorField/SelectorField.ctrl';

export function SoftwareTypeField({
  form,
  softwareNameFilterChange,
  versionFilterChange,
  moduleFilterChange,
}: {
  readonly form: UseFormReturn<FileOutputFormularyModalSchema>;
  readonly softwareNameFilterChange: (value: string) => void;
  readonly versionFilterChange: (value: string) => void;
  readonly moduleFilterChange: (value: string) => void;
}): ReactNode {
  const { t } = useTranslation(Object.values(LNGS_NAMESPACE_LOGICAL_DEVICE));

  const { control, resetField } = form;
  const options = useMemo(() => softwareTypeOptions, []);

  const clearNextFields = useCallback(() => {
    resetField('softwareNameId');
    resetField('versionId');
    resetField('moduleId');
    softwareNameFilterChange('');
    versionFilterChange('');
    moduleFilterChange('');
  }, [moduleFilterChange, resetField, softwareNameFilterChange, versionFilterChange]);
  return (
    <SelectorField
      onChangeTrigger={clearNextFields}
      control={control}
      dataErrorTestId={'software-type--error-field-data-id'}
      dataTestId={'software-type-field-data-id'}
      fieldName={'softwareType'}
      getOptionLabel={(field) => toString(t([`fileOutputModal.label.softwareType.${field}`, '']))}
      inputLabel={t('fileOutputModal.fields.softwareType')}
      options={options}
    />
  );
}
